// @ts-nocheck
import Upload from "@store/Library/Components/Toolkit/Icons/Upload";
import { buttonGetFieldIconProps } from "@store/Themes/common/props/button";
import Styleguide from "@toolkit/Framework/Types/Styleguide";

/* Store Custom Code - Start */
import Close from "@store/Library/Components/Toolkit/Icons/Close";
/* Store Custom Code - End */

const fileUpload: Styleguide["fileUpload"] = {
    defaultProps: {
        ...buttonGetFieldIconProps(Upload, "primary"),
        clearIconProps: { src: Close }, // Store Custom Code
    },
};

export default fileUpload;
